/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import Table from '..';

import Pagination from '~/components/Pagination';

import EmptyTableBody from './EmptyTableBody';
import { BaseEntity, PaginatedTableProps } from './interface';
import { Container } from './styles';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TableRowSkeleton from './TableRow/skeleton';

function PaginatedTable<Entity extends BaseEntity>({
  columns,
  menu,
  loading,
  entities,
  emptyTable,
  borderColor,
  paginationProps,
  selectedEntities,
  sorting,
  multipleActionOption,
  disableMultSelectButton,
  loadingMultSelectButton,
}: PaginatedTableProps<Entity>) {
  return (
    <Container>
      <Table>
        <TableHeader
          columns={columns}
          hasMenu={!!menu}
          hasSelectedEntities={!!selectedEntities}
          hasBorderColor={!!borderColor}
          sorting={sorting}
          multipleActionOption={multipleActionOption}
          disableMultSelectButton={disableMultSelectButton}
          loadingMultSelectButton={loadingMultSelectButton}
        />
        <tbody>
          {!loading && emptyTable && entities?.length === 0 && (
            <EmptyTableBody
              title={emptyTable.title}
              description={emptyTable.description}
            />
          )}
          {!loading ? (
            entities?.map((entity) => (
              <TableRow<Entity>
                entity={entity}
                columns={columns}
                menu={menu}
                borderColor={borderColor && borderColor(entity)}
                selectedEntities={selectedEntities}
              />
            ))
          ) : (
            <TableRowSkeleton
              numberOfRows={15}
              columns={columns}
              hasMenu={!!menu}
              hasSelectedEntities={!!selectedEntities}
              hasBorderColor={!!borderColor}
            />
          )}
        </tbody>
      </Table>
      {paginationProps && <Pagination {...paginationProps} />}
    </Container>
  );
}

export default PaginatedTable;
